
<template>
  <q-modal class="sl-modal"
    :value="open"
    v-if="open"
    @hide="onClose()"
    id="details-modal"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
    :maximized="maximized"
    :content-css="{width: '1200px', maxWidth: '100%', minHeight: '85vh'}">
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title >
          <q-icon name="fa fa-users" />
          <span v-if="mode === 'add'">Add Student</span>
          <span v-if="mode === 'edit'">Edit Student Details</span>
        </q-toolbar-title>
        <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />
        <q-icon @click.native="onClose" name="clear" />
      </q-toolbar>   
      <div class="sl-row sl-abs">
          <div class="sl-col-3 navigation sl-vp">
              <q-list highlight>
                  <q-item :class="{active:selectedTab === 'general'}" @click.native="updateSelectedTab('general')">
                      <q-item-main label="General" />
                  </q-item>
                  <q-item :class="{active:selectedTab === 'addresses'}" @click.native="updateSelectedTab('addresses')">
                      <q-item-main label="Addresses" />
                  </q-item>
                  <q-item :class="{active:selectedTab === 'documents'}" @click.native="updateSelectedTab('documents')">
                      <q-item-main label="Documents" />
                  </q-item>
                  <!-- <q-item v-if="mode === 'edit'" :class="{active:selectedTab === 'security'}" @click.native="updateSelectedTab('security')">
                      <q-item-main label="Security" />
                  </q-item> -->
                  <!-- <q-item v-if="mode === 'edit'" :class="{active:selectedTab === 'notifications'}" @click.native="updateSelectedTab('notifications')">
                      <q-item-main label="Notifications" />
                  </q-item> -->
                  <q-item :class="{active:selectedTab === 'classes'}" @click.native="updateSelectedTab('classes')">
                      <q-item-main label="Classes" />
                  </q-item>
                  <q-item :class="{active:selectedTab === 'notes'}" @click.native="updateSelectedTab('notes')">
                      <q-item-main label="Notes" />
                  </q-item>
              </q-list>
          </div>
          <div id="class-modal-right" class="sl-col-9 sl-vp" style="padding-bottom:60px">
              <h5 class="text-center">
                <q-icon name="fa fa-user" color="primary" /> {{studentForm.STUDENT_FIRST_NAME}} {{studentForm.STUDENT_LAST_NAME}}
              </h5>
              <div class="panel">
                <q-icon name="fa fa-warning" size="30px" /> You can only edit individual student notes / documents here. Go to the <a href="#" @click.prevent="updateSelectedTab('classes')">class</a> directly to edit other information.
              </div>
              <!-- General -->
              <div v-if="selectedTab === 'general'">
                <student-general />
              </div>
              <!-- Addresses -->
              <div v-if="selectedTab === 'addresses'">
                <student-addresses :validation="validation" />
              </div>
              <!-- Documents -->
              <div v-if="selectedTab === 'documents'">
                <student-documents />
              </div>
              <!-- Security -->
              <!-- <div v-if="selectedTab === 'security'">
                <user-security />
              </div> -->
              <!-- Notifications -->
              <!-- <div v-if="selectedTab === 'notifications'">
                <user-notifications />
              </div> -->
              <!-- Classes -->
              <div v-if="selectedTab === 'classes'">
                <student-classes />
              </div>
              <!-- Notes -->
              <div v-if="selectedTab === 'notes'">
                <student-notes />
              </div>
          </div>
      </div>
      <q-toolbar slot="footer" class="sl-footer"> 
        <!-- <q-btn 
          v-if="mode === 'edit' && inApprovedClass != true && $p(['ADMIN'])" 
          color="red" 
          label="Remove" 
          outline 
          icon="delete" 
          @click="onRemove()" 
        />  -->
        <q-toolbar-title> 
        </q-toolbar-title> 
        <div class="q-px-sm"> 
          <q-btn 
            v-if="selectedTab === 'documents'"
            class="q-px-md" 
            label="New Upload" 
            color="blue"
            icon="cloud_upload" 
            @click="openUploadModal()" 
          /> 
        </div> 
        <div class="q-px-sm"> 
          <q-btn 
            v-if="mode === 'edit'" 
            class="q-px-md" 
            color="green" 
            label="Save" 
            @click="onUpdate()" 
          /> 
        </div> 
        <q-btn outline color="faded" @click.native="closeDetails" label="Cancel" /> 
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { required, requiredIf, requiredUnless, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import { driversLicense, USDLRegex } from 'src/utils/validators'
import { notify } from 'src/plugins/notify'
import StudentGeneral from './StudentGeneral'
import StudentAddresses from './StudentAddresses'
import StudentDocuments from './StudentDocuments'
import StudentClasses from './StudentClasses'
import StudentNotes from './StudentNotes'
import { lkKey } from 'src/utils'
const moment = require('moment')

export default {
  name: 'StudentDetailsModal',
  props: ['module'],
  components: {
    StudentGeneral,
    StudentAddresses,
    StudentDocuments,
    StudentClasses,
    StudentNotes
  },
  data () {
    return {
      sparse: true,
      separator: true,
      hideEntity: true,
      maximized: false,
      removeDialogOptions: {
        title: 'Remove Student?',
        message: 'Are you sure you want to remove this student?',
        ok: {
          label: 'Remove',
          color: 'negative'
        },
        cancel: {
          label: 'Cancel'
        }
      }
    }
  },
  validations () {
    return {
      studentForm: {
        STUDENT_FIRST_NAME: { required },
        STUDENT_LAST_NAME: { required },
        STUDENT_EMAIL: { email },
        STUDENT_PHONE: { required }
      },
      driversLicenseForm: {
        DRIVERS_LICENSE: { 
          required, 
          driversLicense: driversLicense('LK_STATE_ID')
        },
        LK_STATE_ID: { required }
      },
      billingAddressForm: {
        ADDRESS_1: { required: false },
        LK_STATE_ID: { requiredIf: requiredIf('CITY') } ,
        ZIP_CODE: { requiredIf: requiredIf('LK_STATE_ID'), minLength: minLength(5), maxLength: maxLength(5), numeric },
        CITY: { requiredIf: requiredIf('ADDRESS_1') },
        COUNTY: { required: false }
      },
      shippingAddressForm: {
        ADDRESS_1: { required: false },
        LK_STATE_ID: (!this.sameAsBilling) ?  { requiredIf: requiredIf('CITY') } :  { required: false },
        ZIP_CODE: (!this.sameAsBilling) ?  { requiredIf: requiredIf('LK_STATE_ID'), numeric, minLength: minLength(5), maxLength: maxLength(5) } : { required: false, numeric },
        CITY: (!this.sameAsBilling) ? { requiredIf: requiredIf('ADDRESS_1') } : { required: false },
        COUNTY: { required: false }
      },
    }
  },
  computed: {
    validation () { 
      return this.$v 
    },
    ...mapState({
      selectedTab: state => state.students.studentModal.selectedTab,
      mode: state => state.students.studentModal.mode
    }),
    ...mapState('students', {
      role: (state) => state.role,
      studentForm: state => state.studentForm,
      billingAddressForm: state => state.billingAddressForm,
      shippingAddressForm: state => state.shippingAddressForm,
      sameAsBilling: state => state.shippingAddressForm.sameAsBilling,
      driversLicenseForm: state => state.driversLicenseForm,
      classStudentList: state => state.classStudentList,
      inApprovedClass: state => state.inApprovedClass,
      list: state => state.list,
      open: state => state.studentModal.open,
      selectedTab: state => state.studentModal.selectedTab,
      mode: state => state.studentModal.mode
    }),
    ...mapGetters('students', [
      'stateAbbrev'
    ])
  },
  methods: {
    driversLicenseValidation (value) {
      if(!value) return true
      const stateRegex = new RegExp(USDLRegex[this.stateAbbrev].rule)
      const valid = stateRegex.test(value)
      return valid
    },
    ...mapActions('students', [
      'add',
      'addNew',
      'select',
      'create',
      'update',
      'remove'
    ]),
    ...mapMutations('students', [
      'openUserModal',
      'closeDetails',
      'toggleMaximized',
      'updateRole',
      'updateSelectedTab'
    ]),
    successHandler (response) {
      this.$v.$reset()
    },
    generateCertificate () {
      this.$store.dispatch('certificates/generateCertificate')
      .then(response => {
        saveAs(
          new Blob([toArrayBuffer(response.data.content.data)],
          {type: 'application/octet-stream'}),
          'cert.pdf'
        )
      })
    },
    onSelect (student) {
      this.select(student).then(this.$v.$touch)
    },
    onAddAnother () {
      this.addAnother().then(this.successHandler)
    },
    onAddNew () {
      this.addNew().then(this.successHandler)
    },
    onAdd () {
      this.add().then(this.successHandler)
    },
    onUpdate () {
      this.update().then(this.successHandler)
    },
    onRemove () {
      this.$q.dialog(this.removeDialogOptions)
      .then(this.remove)
      .catch(err => err)
    },
    openUploadModal () {
      this.$store.dispatch('documents/openUploadModal', 
      { LK_ENTITY_ID: 2, ENTITY_ITEM_ID: this.studentForm.STUDENT_ID }, 
      { root: true })
    },
    onClose () {
      this.closeDetails()
    },    
    toggleMaximized(){
        this.maximized = !this.maximized
    }
  }
}

</script>

<style lang="stylus" scoped>
  @import '~variables'
  .details-inner
    position absolute 
    height 100%
    width 100%
    .q-tabs-head
      z-index 2
      background-color lighten(border-color,80%) !important
      .q-tab.active
        border-bottom-color
        .q-tabs-bar 
          border-bottom-color $primary
        .q-tab-label
          color $primary
      .q-tab-label
        color text-color
    .sl-row.sl-abs
      height calc(100% - 60px)
      > .sl-col-12
        position absolute 
        top 50px
    .q-toolbar.sl-footer
      position absolute 
      bottom 0
      background white !important
      border-top 1px solid border-color
</style>
